export const messages = {
  modal: {
    title: {
      id: 'termsOfUse.Modal.Title',
      defaultMessage: 'Terms of Use',
    },
  },
  button: {
    close: {
      id: 'termsOfUse.Modal.Button.Close',
      defaultMessage: 'Close',
    },
  },
};
